<template lang="pug">
v-flex 
  v-card
    v-card-title Almacén
      v-spacer
      v-text-field(v-model='search' append-icon='fa-search' label='Buscar almacén' single-line hide-details)
      MassiveWarehouse
      v-dialog(v-model='Warehouse.dialog' max-width='500px')
        template(v-slot:activator='{ on }')
          v-btn.mb-2(color='primary' dark v-on='on' @click='clearForm()') Añadir
        v-card
          v-card-title
            span.headline {{ title }}
          v-card-text
            v-container(grid-list-md)
              v-layout(wrap)
                v-flex(xs12)
                  v-text-field(v-model='Datos.name' label='Nombre')
                v-flex(xs12 )
                  v-select(v-model='Datos.attendant' :items='usersRecord' item-text='name' label='Encargado')
                v-flex(xs12)
                  v-switch(v-model='Datos.isMain' label='Almacén principal')
                v-flex(xs12)
                  v-switch(v-model='Datos.isTotal' label='Almacén total')
                v-flex(xs12)
                  v-layout.fill-width
                    v-flex
                      v-text-field(v-model='dirección.ubicación' label='Dirección')
                    
                  v-layout.fill-width
                    v-col
                      MinicrudCombobox( @resultado="val => dirección.departamento = val" arreglo='Departamento' :requiere_codigo='true')
                    v-col
                      MinicrudCombobox( @resultado="val => dirección.provincia = val" arreglo='Provincia' :requiere_codigo='true')
                    v-col
                      MinicrudCombobox( @resultado="val => dirección.distrito = val" arreglo='Distrito' :requiere_codigo='true')
                    v-flex
                      v-btn(@click='agregar_dirección(dirección)' color='primary' ) 
                        v-icon fas fa-plus
                  v-list
                    v-subheader Direcciones
                    template(v-for='dirección in Datos.direcciones')
                      v-list-item
                        v-list-item-content
                          v-list-item-title( v-text='dirección.ubicación' )
                          v-list-item-subtitle( v-text='dirección.ubigeo' ) 
                        v-list-item-action(@click='eliminar_dirección(dirección)' )
                          v-icon(color='primary' small ) far fa-trash-alt
                

          v-card-actions
            v-spacer
            v-btn(color='primary' @click='save()') Guardar
    v-data-table.elevation-1(:headers='headers' :items=' warehouseRecord' :search='search')
      template(v-slot:item.direcciones='{item}')
        v-chip(color='primary' v-if='item.direcciones') {{item.direcciones.length}}
      template(v-slot:item.action='{item}')
        v-btn(color='secondary' icon @click='editItem(item.key)')
          v-icon(small) far fa-edit
        v-btn(color='secondary' icon @click='deleteItem(item.key)')
          v-icon(small) far fa-trash-alt
</template>

<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data: () => ({
    search: '',
    headers: [
      { text: 'Nombre', value: 'name' },
      { text: 'Direcciones', value: 'direcciones'},
      { text: '', value: 'action', sortable: false }
    ],
    dirección: {
      ubicación: '',
      ubigeo: '',
      distrito: '',
      provincia: '',
      departamento: '',
    },
  }),
  methods:{
    ...mapActions({
      editItem: 'Warehouse/get',
      deleteItem: 'Warehouse/clean',
      save: 'Warehouse/add',
      clearForm: 'Warehouse/clearForm',
    }),
    agregar_dirección(dirección){
      if( !this.Datos.direcciones ) this.Datos.direcciones = []
      this.Datos.direcciones.push({
        ubicación: `${dirección.ubicación} ${dirección.distrito.descripcion} ${dirección.provincia.descripcion} ${dirección.departamento.descripcion}`, 
        ubigeo: `${dirección.departamento.codigo}${dirección.provincia.codigo}${dirección.distrito.codigo}`
      })
      this.dirección.ubicación = ''
    },
    eliminar_dirección(dirección){
      this.Datos.direcciones.splice( this.Datos.direcciones.indexOf(dirección), 1)
    }
  },
  computed:{
    title() { return this.Warehouse.selectedKey == '' ? 'Registar' : 'Crear' },
    titleButton() { return this.Warehouse.selectedKey == "" ? 'Guardar' : 'Editar' },
    ...mapGetters({
      usersRecord: 'Users/record',
      warehouseRecord: 'Warehouse/record',
    }),
    ...mapState({
        Datos: state=> state.Warehouse.data,
        Warehouse: state=> state.Warehouse,
    })
  },
  components: {
    MassiveWarehouse: ()=>import('.././components/MassiveWarehouses'),
    MinicrudCombobox : ()=>import('@/components/minicrud_combobox')
  },
}
</script>
